"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var buildSports = function buildSports(_ref) {
  var _ref$items = _ref.items,
      items = _ref$items === void 0 ? {} : _ref$items,
      t = _ref.t;
  var activityTypes = Object.keys(items).filter(function (item) {
    return item !== 'default';
  }).map(function (item) {
    return {
      value: item,
      label: t("ds-filters.types.".concat(item.toLowerCase()))
    };
  }).sort(function (x, y) {
    return x.value === 'All' ? -1 : y.value === 'All' ? 1 : x.label > y.label ? 1 : -1;
  });
  return activityTypes;
};

var filterGroupingWithoutParent = function filterGroupingWithoutParent(_ref2) {
  var grouping = _ref2.grouping,
      groupParent = _ref2.groupParent;

  if (!groupParent) {
    return grouping.filter(function (groupingItem) {
      return (groupingItem === null || groupingItem === void 0 ? void 0 : groupingItem.key) !== 'allGroupsChildren' && (groupingItem === null || groupingItem === void 0 ? void 0 : groupingItem.key) !== 'groupsChildren';
    });
  }

  return grouping;
};

var filterGrouping = function filterGrouping(_ref3) {
  var grouping = _ref3.grouping,
      hasLiteFeatures = _ref3.hasLiteFeatures,
      groupParent = _ref3.groupParent;

  if (hasLiteFeatures) {
    var newGrouping = grouping.filter(function (groupingItem) {
      return (groupingItem === null || groupingItem === void 0 ? void 0 : groupingItem.key) !== 'groupsTopParent';
    });
    return filterGroupingWithoutParent({
      grouping: newGrouping,
      groupParent: groupParent
    });
  }

  return filterGroupingWithoutParent({
    grouping: grouping,
    groupParent: groupParent
  });
};

var buildFilterOptions = function buildFilterOptions(_ref4) {
  var _ref4$items = _ref4.items,
      items = _ref4$items === void 0 ? {} : _ref4$items,
      t = _ref4.t;
  var options = Object.entries(items).map(function (item) {
    var key = item[0];
    var value = item[1];

    if (key !== 'default') {
      return {
        key: key,
        value: key,
        label: t("ds-filters.label.".concat(key)),
        isEnabled: value
      };
    }

    return null;
  });
  return options.filter(function (item) {
    return item !== null;
  });
};

var buildFilterConfig = function buildFilterConfig(_ref5) {
  var featureConfig = _ref5.featureConfig,
      hasLiteFeatures = _ref5.hasLiteFeatures,
      groupParent = _ref5.groupParent,
      t = _ref5.t;
  var config = {
    sport: buildSports({
      items: featureConfig.sport,
      t: t
    }),
    sportCategory: buildSports({
      items: featureConfig.sportCategory,
      t: t
    }),
    grouping: {
      label: t('ds-filters.label.grouping'),
      key: 'grouping',
      options: filterGrouping({
        grouping: buildFilterOptions({
          items: featureConfig.grouping,
          t: t
        }),
        hasLiteFeatures: hasLiteFeatures,
        groupParent: groupParent
      })
    },
    period: {
      label: t('ds-filters.label.period'),
      key: 'period',
      options: buildFilterOptions({
        items: featureConfig.period,
        t: t
      })
    },
    sort: {
      label: t('ds-filters.label.sort'),
      key: 'sort',
      options: buildFilterOptions({
        items: featureConfig.sort,
        t: t
      })
    },
    calculationMethod: {
      label: t('ds-filters.label.calculationmethod'),
      key: 'calculationMethod',
      options: buildFilterOptions({
        items: featureConfig.calculationMethod,
        t: t
      })
    }
  };
  return config;
};

var _default = buildFilterConfig;
exports["default"] = _default;
//# sourceMappingURL=buildFilterConfig.js.map